/**
 * Maps backend i18n keys for addNewLearningSpace and deleteLearningSpace
 * to user-facing messages. Replace with t(i18nKey) when i18n is available.
 */

export const LEARNING_SPACE_ERROR_MESSAGES: Record<string, string> = {
  // Shared
  USER_NOT_FOUND: "User not found.",
  USER_DOES_NOT_HAVE_A_LEARNER_ROLE: "User does not have the required role (learner or coach).",
  ORGANIZATION_LEARNER_CANNOT_CREATE_SPACE: "Organization learners cannot create or manage learning spaces.",
  SESSIONS_TEMPORARILY_DISABLED: "Sessions are temporarily disabled for this user.",
  UPCOMING_SESSIONS_EXIST: "Cannot perform this action while upcoming sessions exist.",
  UPCOMING_BOOKINGS_EXIST: "Cannot perform this action while upcoming bookings exist.",

  // deleteLearningSpace only
  NO_ACTIVE_LEARNING_SPACE: "No active learning space to delete.",
  LEARNING_SPACE_NOT_ACTIVE: "The learning space is not active.",
  LEARNING_SPACE_NOT_FOUND_FOR_LANGUAGE: "Learning space not found for this language.",
};

/**
 * Returns a user-friendly message for a learning space error.
 * If the raw message is a known i18n key, returns the mapped message; otherwise returns the raw message.
 */
export function getLearningSpaceErrorMessage(
  rawMessage: string,
  fallback: string = "Something went wrong."
): string {
  const key = rawMessage?.trim();
  if (!key) return fallback;
  return LEARNING_SPACE_ERROR_MESSAGES[key] ?? rawMessage;
}
